import { handleResponse } from "../../../helpers/handleresponse";
import { authHeader } from "../../../helpers/authHeader";

export const formService = {
  update,
  get,
  create,
  getAll,
  post,
  postSurvey,
  deleteForm,
  getSurvey,
  // setSqlState,
  checkForUpdates,
  getAllPaths,
  screenshot
};
// async function setSqlState(stateNo, eventId, state) {
//   const requestOptions = {
//     method: "POST",
//     headers: /* authHeader( */{ "Content-Type": "application/json" }/* ) */,
//     body: JSON.stringify({
//       sqlStateNo: stateNo,
//       eventId,
//       add: state
//     })
//   };

//   return fetch(`./api/form/state`, requestOptions)
//     .then(handleResponse);
// }

async function getAll(eventId, isSurvey) {
  const requestOptions = {
    method: "GET",
    headers: /* authHeader( */{ "Content-Type": "application/json" }/* ) */
  };

  return fetch(`./api/form/getAll/${eventId}/?isSurvey=${isSurvey}`, requestOptions)
    .then(handleResponse)
    .then(forms => {
      return forms;
    });
}
async function getAllPaths(eventId) {
  const requestOptions = {
    method: "GET",
    headers: /* authHeader( */{ "Content-Type": "application/json" }/* ) */
  };

  return fetch(`./api/form/getAllPaths/${eventId}`, requestOptions)
    .then(handleResponse)
    .then(forms => {
      return forms;
    });
}

async function checkForUpdates(form) {
  const requestOptions = {
    method: "POST",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify(form)
  };

  return fetch(`./api/form/checklastupdate`, requestOptions)
    .then(handleResponse)
    .then(isModified => {
      return isModified;
    });
}

async function post(orders) {
  const requestOptions = {
    method: "POST",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify(orders)
  };

  return fetch(`./api/form/post/`, requestOptions)
    .then(handleResponse)

}

async function postSurvey(orders) {
  const requestOptions = {
    method: "POST",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify(orders)
  };

  return fetch(`./api/form/post/survey`, requestOptions).then(handleResponse);
}


async function get(formId, registerMode, getNewStateId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader({ "Content-Type": "application/json" })
  };
  console.log('GET_FORM')
  return fetch(`./api/form/${formId}/?registerMode=${registerMode}&newStateId=${getNewStateId}`, requestOptions)
    .then(handleResponse)
    .then(form => {
      return form;
    });
}
async function getSurvey(code) {
  const requestOptions = {
    method: "GET",
    headers: authHeader({ "Content-Type": "application/json" })
  };
  let url = `./api/form/survey/${code}`;
  
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(form => {
      return form;
    });
}

async function create(form) {
  const requestOptions = {
    method: "POST",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify(form)
  };

  return fetch(`./api/form`, requestOptions)
    .then(handleResponse)
    .then(form => {
      return form;
    });
}
async function screenshot(formId, pages) {
  const requestOptions = {
    method: "POST",
    headers: authHeader({ "Content-Type": "application/json" }),
  };

  return fetch(`./api/files/formscreenshot/${formId}?pages=${pages}&alphaId=${formId.toString(36)}`, requestOptions)
    .then(handleResponse);
}

async function update(form) {

  const requestOptions = {
    method: "PUT",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify(form)
  };

  return fetch(`./api/form`, requestOptions)
    .then(handleResponse)
    .then(form => {
      return form;
    });
}
async function deleteForm(formId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader({ "Content-Type": "application/json" }),
  };

  return fetch(`./api/form/${formId}`, requestOptions)
    .then(handleResponse);
  // .then(form => {
  //   return form;
  // });
}
/* async function create(element) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(element)
  };

  return fetch(`./api/formElement`, requestOptions)
    .then(handleResponse)
    .then(element => {
      return element;
    });
} */
